"use client"
import { determineABTestVariation } from "utils/ab-test"

export enum SearchPviAlgoABTestVariants {
  V0_PVI_ALGO = "v1",
  V1_PVI_ALGO = "v0",
}

export const VARIANT_KEY = "search_pvi_algo_ab_test"
export const VARIANT_OPTIONS: string[] = [
  SearchPviAlgoABTestVariants.V0_PVI_ALGO,
  SearchPviAlgoABTestVariants.V1_PVI_ALGO,
]

export const VARIANT_WEIGHTS: number[] = [50, 50] as const
export const DEFAULT_VARIANT = SearchPviAlgoABTestVariants.V0_PVI_ALGO

export const getSearchPviAlgoABTestVariant = () => {
  return determineABTestVariation(
    VARIANT_KEY,
    VARIANT_OPTIONS,
    VARIANT_WEIGHTS,
    DEFAULT_VARIANT,
  ) as SearchPviAlgoABTestVariants
}

// const useSearchPviAlgoABTesting = () => {
//   const [variant, setVariant] = useState<SearchPviAlgoABTestVariants | null>(null)

//   useEffect(() => {
//     const selectedVariant = getSearchPviAlgoABTestVariant()

//     setVariant(selectedVariant)
//   }, [])

//   return variant
// }

// export default useSearchPviAlgoABTesting
